import PropTypes from 'prop-types';
import React from 'react';

const TrophyScoreComponent = React.memo(({ percent }) => (
  <span className="ml6 fs24 smart-maps-trophies-overall-trophy-score">
    {percent}%
  </span>
));

TrophyScoreComponent.propTypes = {
  percent: PropTypes.number.isRequired,
};

TrophyScoreComponent.displayName = 'TrophyScoreComponent';

export default TrophyScoreComponent;
